import type { PartnerSessionMetadata } from './partnerSession';

export type PartnerObservabilityEvent =
  | 'session_started'
  | 'session_failed'
  | 'session_expired'
  | 'booking_submitted'
  | 'receipt_displayed'
  | 'exit_clicked'
  | 'location_filter_fallback';

type PartnerObservabilityPayload = {
  event: PartnerObservabilityEvent;
  source: 'blr_pulse_sso';
  partnerId?: string;
  reason?: string;
  transactionId?: string;
};

export const buildPartnerObservabilityPayload = ({
  event,
  partnerSession,
  reason,
  transactionId,
}: {
  event: PartnerObservabilityEvent;
  partnerSession?: PartnerSessionMetadata | null;
  reason?: string;
  transactionId?: string;
}): PartnerObservabilityPayload => ({
  event,
  source: 'blr_pulse_sso',
  ...(partnerSession?.partnerId ? { partnerId: partnerSession.partnerId } : {}),
  ...(reason ? { reason } : {}),
  ...(transactionId ? { transactionId } : {}),
});

export const emitPartnerObservabilityEvent = (
  args: Parameters<typeof buildPartnerObservabilityPayload>[0],
): PartnerObservabilityPayload => {
  const payload = buildPartnerObservabilityPayload(args);

  window.dispatchEvent(
    new CustomEvent<PartnerObservabilityPayload>('blr-pulse-sso-event', {
      detail: payload,
    }),
  );

  return payload;
};
